import React,{useState} from 'react'

import { Button,Modal, } from 'react-bootstrap';
import Cancel from '../../assets/cross.svg';
import {navigate} from 'gatsby';
import Alert from '../../assets/alert.svg'
export default function SaveAsTempModal(props) {
    const redirectionHandel = () =>{
        navigate('/templates?doc_type_id='+props.doc_type_id);
    }
    return (
        <Modal
          {...props}
          onHide={() => props.setModalShow(true)}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          style={{opacity:'1'}}
        >
          <Modal.Header>
          <img onClick={()=>props.setModalShow(false)} src={Cancel} style={{width: "26px", position: 'absolute', right: '1.5rem', top: '1.5rem' , backgroundColor: 'transparent' , cursor: 'pointer', border: 'none'}}/>
            <Modal.Title id="contained-modal-title-vcenter">
                {/* <div className="text-center my-3">
                    <img src={Alert} style={{width:'75px', height:'auto'}} alt=""/>
                </div> */}
                <p className="modal-title-x text-center mt-5 mb-0">New template has been created. Go to Templates?</p>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-0">
          </Modal.Body>
          <Modal.Footer>
            <Button className="modal-btn-x" onClick={redirectionHandel}>Okay</Button>
            <Button className="modal-btn-x" onClick={()=>props.setModalShow(false)}>Cancel</Button>
          </Modal.Footer>
        </Modal>
      );
  }
  
